import React, { Component } from 'react';
import queryString from 'query-string';
import firebase from 'firebase/app';
import { firebaseApp } from './firebase/';

import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Jumbotron from 'react-bootstrap/Jumbotron'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from 'react-toastify'

import {
  SignInButtons,
  saveSignInParam,
  createGoogleAuthProvider,
  onAuthStateChanged,
} from './task/SignInButtons'
import UserNavbar from './task/UserNavbar'
import ContentAlert from './task/ContentAlert'
import YouTubeLink from './task/YouTubeLink'
import Footer from './task/Footer'
import ContentsCard from './contents/ContentsCard'
import Description from './task/Description'
import Agreement, { checkAgreement } from './common/Agreement'
import UnauthorizedUser from './common/UnauthorizedUser'

import './ContentsApp.css';


const db = firebaseApp.firestore();
const storage = firebaseApp.storage()
const CARD_ORDERS = [
  {
    title: 'すべて(追加順)',
    order: 'default',
  },
  {
    title: 'すべて(タイトル順)',
    order: 'title',
  },
  {
    title: '実施中のみ',
    order: 'notcompleted',
  },
  {
    title: '未実施のみ',
    order: 'notperformed',
  },
]

class ContentsApp extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/contents/')),
      user: null,
      loading: true,
      error: null,
      tasks: null,
      order: 'default',
      needAgreement: false,
    };
  }

  auth() {
    return this.props.auth || firebase.auth();
  }

  get query() {
    return this.props.query || queryString.parse(window.location.search);
  }

  get db() {
    return this.props.db || db;
  }

  get storage() {
    return this.props.storage || storage
  }

  componentDidMount() {
    onAuthStateChanged(this.auth(), (user, error) => {
      if (error) {
        this.showError(error);
        return;
      }
      this.loadTasks(user)
        .then(result => {
          console.log('LOADED', result)
          this.setState({
            loading: false,
            user,
            title: result.title || null,
            description: result.description || null,
            updated: result.updated || 0,
            require_auth: result.require_auth || false,
            whitelist_auth: result.whitelist_auth || '',
            tasks: result.tasks || [],
            incompleteTasks: result.incompleteTasks || [],
            alerts: result.alerts || [],
            needAgreement: result.needAgreement || false,
            agreement: result.agreement || null,
            userAgreement: result.userAgreement || null,
          })
        }).catch((error) => {
          this.showError(error)
        })
    })
  }

  showError(error) {
    console.error(error)
    this.setState({
      loading: false,
      error: error.message || error,
    })
  }

  componentDidUpdate(prevProps, prevState) {
    this.emitErrorToast(prevState)
  }

  emitErrorToast(prevState) {
    if (prevState.error === this.state.error || this.state.error === null) {
      return
    }
    toast.error(`Error: ${this.state.error}`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      onClose: () => this.setState({
        error: null
      })
    })
  }

  signIn(provider) {
    this.auth().signInWithRedirect(provider)
  }

  reSignIn() {
    this.signOut(() => {
      this.signIn(createGoogleAuthProvider())
    })
  }

  signOut(callback) {
    this.auth().signOut()
      .then(() => {
        this.setState({
          user: null,
        }, callback);
      }).catch((error) => {
        console.error(error)
        this.setState({
          error: error.message || error,
        })
      })
  }

  canAccess() {
    if (!this.state.require_auth) {
      return true
    }
    if (!this.state.user || !this.state.user.email) {
      return false
    }
    const whitelist = (this.state.whitelist_auth || '')
      .split(';').map(d => d.trim()).filter(d => d.length > 0)
    if (whitelist.length === 0) {
      return true
    }
    return whitelist.some(domain => this.state.user.email.endsWith(domain))
  }

  async loadAlerts(user) {
    const publicAlerts = await this.db
      .collection('alert')
      .where('public', '==', true)
      .get()
    const domainAlerts = user.email.includes('@') ? (await this.db
      .collection('alert')
      .where('domain', '==', user.email.substring(user.email.indexOf('@')))
      .get()) : { docs: [] }
    const serializeAlert = (alert) => ({
      id: alert.id,
      variant: alert.data().variant,
      title: alert.data().title,
      message: alert.data().message,
      visible: alert.data().visible,
    })
    return domainAlerts.docs.map(serializeAlert)
      .concat(publicAlerts.docs.map(serializeAlert))
      .filter((alert) => alert.visible)
  }

  async loadTasks(user) {
    const contentRef = await this.db.collection('contents')
      .doc(this.props.match.params.content).get()
    if (!contentRef.exists) {
      throw new Error(`Content not found: ${this.props.match.params.content}`)
    }
    const result = contentRef.data()
    if (result.cloze) {
      const cloze = await Promise.all(result.cloze.map(cloze_id => this.db
        .collection('task')
        .doc(cloze_id)
        .get()))
      const clozeRecord = user === null ?
        result.cloze.map(cloze_id => ({
          exists: false
        })) :
        await Promise.all(result.cloze.map(cloze_id => this.db
          .collection('user').doc(user.uid)
          .collection('taskref')
          .doc(cloze_id)
          .get()))
      result.tasks = result.cloze.map((cloze_id, cloze_index) => ({
        id: cloze_id,
        thumbnail: result.thumbnails[cloze_index] || null,
        data: cloze[cloze_index].exists ? cloze[cloze_index].data() : null,
        record: clozeRecord[cloze_index].exists ? clozeRecord[cloze_index].data() : null,
      }))
    }
    const { needAgreement, agreement, userAgreement } = await checkAgreement(
      this.db, user, contentRef.data(),
    )
    result.needAgreement = needAgreement
    result.agreement = agreement
    result.userAgreement = userAgreement
    if (user === null) {
      return result
    }
    const userRef = await this.db
      .collection('user').doc(user.uid).get()
    await saveSignInParam(this.db.collection('user'), userRef)
    const taskRefs = await this.db
      .collection('user').doc(user.uid)
      .collection('taskref').where('completed', '==', false).get()
    result.incompleteTasks = taskRefs.docs.map(taskRef => ({
      id: taskRef.id,
      data: taskRef.data(),
    }))
    result.alerts = await this.loadAlerts(user)
    await this.db
      .collection('user').doc(user.uid)
      .collection('contentsref').doc(contentRef.id)
      .set({
        accessed: Date.now(),
        title: result.title,
      })
    return result
  }

  renderIntroduction() {
    return <div>
      <p>Cloze Testは、一部が空欄になった文章を穴埋めすることで解くスタイルの英語問題です。</p>
      <p>
        <YouTubeLink title="使い方動画(YouTube)" youtubeid="DOT9vOMHols" />
      </p>
    </div>
  }

  renderControls() {
    return <div className='OrderControls'>
      <ButtonGroup toggle>
        {CARD_ORDERS.map((radio, idx) => (
          <ToggleButton
            key={idx}
            type="radio"
            variant="light"
            name="radio"
            value={radio.order}
            checked={this.state.order === radio.order}
            onChange={(e) => this.setState({
              order: e.currentTarget.value
            })}
          >
            {radio.title}
          </ToggleButton>
        ))}
      </ButtonGroup>
    </div>
  }

  compareString(text1, text2) {
    if (text1 < text2) {
      return -1
    }
    if (text1 > text2) {
      return 1
    }
    return 0
  }

  compareTask(task1, task2) {
    if (!task1.data || !task2.data) {
      return 0
    }
    if (!task1.data.title || !task2.data.title) {
      return 0
    }
    const pattern = /^(.+)\s+([0-9]+)$/
    const task1Match = task1.data.title.match(pattern)
    const task2Match = task2.data.title.match(pattern)
    if (!task1Match || !task2Match) {
      return this.compareString(task1.data.title, task2.data.title)
    }
    const r = this.compareString(task1Match[1], task2Match[1])
    if (r !== 0) {
      return r
    }
    const task1Ch = parseInt(task1Match[2])
    const task2Ch = parseInt(task2Match[2])
    if (task1Ch < task2Ch) {
      return -1
    }
    if (task1Ch > task2Ch) {
      return 1
    }
    return 0
  }

  renderCards() {
    let tasks = (this.state.tasks || []).slice()
    if (this.state.order === 'notcompleted') {
      tasks = tasks.filter(t => t.record === null || !t.record.completed)
    } else if (this.state.order === 'notperformed') {
      tasks = tasks.filter(t => t.record === null)
    } else if (this.state.order === 'title') {
      tasks.sort((task1, task2) => this.compareTask(task1, task2))
    }
    if (tasks.length === 0) {
      return <div>
        条件に合致する問題はありません。
      </div>
    }
    return <Container className='ContentsCardsPanel'>
      {tasks.map((task, index) =>
        <Row key={index}>
          <Col className='ContentsCardPanel'>
            <ContentsCard baseURL={this.state.baseURL} task={task} />
          </Col>
        </Row>)}
    </Container>
  }

  render() {
    return <div>
      <UserNavbar
        incompleteTasks={this.state.incompleteTasks || null}
        user={this.state.user}
        onSignOut={() => this.signOut()}/>
      <div className='ContentsApp'>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          />
        {this.state.loading ? <div className='Loading'>
          <ClipLoader />
          <div data-testid='loading'>Loading...</div>
        </div> : ((this.state.user === null && this.state.require_auth) ? <div className='Login'>
          <Jumbotron>
            <h1>Cloze Testコンテンツ一覧</h1>
            <SignInButtons
              description='Cloze Testコンテンツ一覧を参照するためには、'
              option={this.state.whitelist_auth && <div className='DomainWhitelist'>
                  【ご注意】認証はGoogleアカウント <strong>{this.query.domain || this.state.whitelist_auth}</strong> を使用してください。
                </div>}
              signIn={(provider) => this.signIn(provider)}
            />
          </Jumbotron>
          <h2>Cloze Testアプリ</h2>
          {this.renderIntroduction()}
        </div> : (!this.canAccess() ?
          <div>
            <UnauthorizedUser
              query={this.query}
              title={this.state.title}
              whitelist_auth={this.state.whitelist_auth}
              onSignIn={() => this.reSignIn()}
            />
          </div> :
          <div>
            {this.state.title ? <Jumbotron>
              <h1>{this.state.title}</h1>
            </Jumbotron> : ''}
            {this.state.description ? <div className='ContentsDescription'>
              <Description markdown={this.state.description} />
            </div> : ''}
            {(this.state.alerts && this.state.alerts.length > 0 && !this.state.needAgreement) && <div className='AlertMargin'></div>}
            {!this.state.needAgreement && (this.state.alerts || []).map((alert) => <ContentAlert
                key={alert.id}
                variant={alert.variant}
                title={alert.title}
                message={alert.message}
              />)}
            {!this.state.needAgreement && this.renderControls()}
            {!this.state.needAgreement && this.renderCards()}
            {this.state.agreement && <Agreement
                db={this.db}
                storage={this.storage}
                user={this.state.user}
                agreement={this.state.agreement}
                needAgreement={this.state.needAgreement}
                userAgreement={this.state.userAgreement}
                onChange={(newNeedAgreement, newUserAgreement) => this.setState({
                  userAgreement: newUserAgreement,
                  needAgreement: newNeedAgreement,
                })}
                onError={(error) => this.showError(error)}
              />}
          </div>))}
      </div>
      <Footer />
    </div>
  }
}

export default ContentsApp;
